import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import uz from './uz.json'
import en from './en.json'

const savedLang = localStorage.getItem('turnifly_lang') ?? 'uz'

i18n.use(initReactI18next).init({
  resources: {
    uz: { translation: uz },
    en: { translation: en },
  },
  lng: savedLang,
  fallbackLng: 'uz',
  interpolation: { escapeValue: false },
})

export { i18n }
